var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsericonResponsive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 11C1 5.477 5.477 1 11 1s10 4.477 10 10-4.477 10-10 10S1 16.523 1 11z",
    fill: "#FFF",
    stroke: "#F0B70D"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F6B119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.991 15.056v-.342c.036-1.599-1.352-2.93-3.123-2.993H9.121c-1.77.064-3.155 1.395-3.117 2.992 0 .006-.006.013-.006.019v.33c0 2.916 9.993 2.79 9.993-.006zM10.998 5a2.735 2.735 0 1 0 0 5.47 2.735 2.735 0 0 0 0-5.47z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericonResponsive);
export default __webpack_public_path__ + "static/media/usericon-responsive.7f882b8ad5aac9c5600c3b0519c68a7a.svg";
export { ForwardRef as ReactComponent };